import React from "react";
import Routing from "./routing/routing";

function App(props) {
  return (
    <div>
      <Routing />
    </div>
  );
}

export default App;
